export var TaskCompletionStatusEnum;
(function (TaskCompletionStatusEnum) {
    TaskCompletionStatusEnum[TaskCompletionStatusEnum["New"] = 0] = "New";
    TaskCompletionStatusEnum[TaskCompletionStatusEnum["InProgress"] = 1] = "InProgress";
    TaskCompletionStatusEnum[TaskCompletionStatusEnum["Completed"] = 2] = "Completed";
    TaskCompletionStatusEnum[TaskCompletionStatusEnum["Rejected"] = 3] = "Rejected";
})(TaskCompletionStatusEnum || (TaskCompletionStatusEnum = {}));
export const TaskCompletionStatusEnumDisplay = {
    [TaskCompletionStatusEnum.New]: 'New',
    [TaskCompletionStatusEnum.InProgress]: 'In Progress',
    [TaskCompletionStatusEnum.Completed]: 'Completed',
    [TaskCompletionStatusEnum.Rejected]: 'Rejected'
};
